import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-402be59e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-mobile-toolbar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-toolbar-title" }, " Clientes ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-toolbar-actions" }, null, -1))
const _hoisted_4 = { class: "ant-row ui-mb-20" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_6 = { class: "ant-input-affix-wrapper" }
const _hoisted_7 = { class: "ant-input-prefix" }
const _hoisted_8 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, null, -1))
const _hoisted_11 = { class: "ui-table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Nome/Razão Social "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Fantasia "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell" }, " Código "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " CPF/CNPJ "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-8 ui-cell" }, " Endereço ")
], -1))
const _hoisted_13 = { class: "ui-rows" }
const _hoisted_14 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "Nome/Razão Social"
}
const _hoisted_15 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "Fantasia"
}
const _hoisted_16 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-2 ui-cell ui-ellipsis",
  "data-title": "Código"
}
const _hoisted_17 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "CPF/CNPJ"
}
const _hoisted_18 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-8 ui-cell",
  "data-title": "Endereço"
}
const _hoisted_19 = { style: {"display":"block","font-size":"12px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "ui-toolbar-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltarTela && _ctx.voltarTela(...args)))
      }, " ‹ "),
      _hoisted_2,
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_icone, { nome: "pesquisar" })
            ])
          ]),
          _withDirectives(_createElementVNode("input", {
            placeholder: "Digite o Nome/Razão Social, CPF/CNPJ ou código do cliente",
            type: "text",
            class: "ant-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.parametrosConsulta.valorPesquisa) = $event)),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarClientePorNome()))
          }, null, 544), [
            [_vModelText, _ctx.state.parametrosConsulta.valorPesquisa]
          ])
        ])
      ]),
      _hoisted_9,
      _hoisted_10
    ]),
    _createVNode(_component_a_skeleton, {
      loading: _ctx.appBase.carregando
    }, {
      default: _withCtx(() => [
        ((_ctx.state.clientes.length > 0))
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.clientes, (Cliente) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: Cliente.codigo,
                        class: "ant-row ui-row"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_router_link, {
                            title: Cliente.nome + ' - ' + Cliente.nomeFantasia,
                            class: "ui-link",
                            to: { name: 'ForcaVendasClientesCadastroEditar', params: { codigo:Cliente.codigo }}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(Cliente.nome), 1)
                            ]),
                            _: 2
                          }, 1032, ["title", "to"])
                        ]),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(Cliente.nomeFantasia), 1),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(Cliente.codigoErp), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(Cliente.cpfCnpj)), 1),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.montarApresentacaoEndereco(Cliente)), 1),
                            _hoisted_20,
                            _createElementVNode("span", null, _toDisplayString(_ctx.montarApresentacaoCidadeCepEndereco(Cliente)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_pagination, {
                      class: "ui-pagination",
                      current: _ctx.appBase.paginacao.paginaAtual,
                      "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.appBase.paginacao.paginaAtual) = $event)),
                      size: "small",
                      total: _ctx.appBase.paginacao.totalRegistros,
                      "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} clientes`,
                      "page-size": _ctx.appBase.paginacao.qtdeRegistrosPagina,
                      "show-size-changer": "",
                      onShowSizeChange: _ctx.qtdeRegistrosPaginaAlterada,
                      onChange: _ctx.paginacaAlterada
                    }, null, 8, ["current", "total", "show-total", "page-size", "onShowSizeChange", "onChange"])
                  ])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_result, {
              key: 1,
              status: "404",
              title: "Nenhum cliente encontrado",
              "sub-title": "Verifique os seus filtros ou efetue um novo cadastro."
            }))
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}